import React, { useEffect } from "react";

//Parallax
import HomePageVideo from "../Landing/HomePageVideo"
import { Controller, Scene } from "react-scrollmagic"
import useOffsetY from "../../components/useOffsetY"
import styled from 'styled-components';
import useWindowSize from "../../components/useWindowSize"

const SectionWipesStyled = styled.div`
  overflow: hidden;

  .panel {
    height: 100vh;
    width: 100vw;
  }

`;

function HomePageHeader() {

  // let pageHeader = React.createRef();
  const { height } = useWindowSize()
  const { offsetY } = useOffsetY()

  const videoRef = React.createRef();
  useEffect(() => {
    setTimeout(() => {
      if (offsetY < height) {
        videoRef.current && videoRef.current.play()
      }
      else {
        //Pause video if the video is out of view
        videoRef.current && videoRef.current.pause()
      }
    }, 150);

  }, [videoRef, offsetY, height])

  return (
    <>
      <div className="cd-section" id="home">
        <SectionWipesStyled>
          <Controller globalSceneOptions={{ triggerHook: 'onLeave' }}>
            <Scene pin>
              <div className="panel">
                <HomePageVideo offsetY={offsetY} videoRef={videoRef} />
              </div>
            </Scene>
          </Controller>
        </SectionWipesStyled>
      </div>
    </>
  );
}

export default HomePageHeader;
